<template>
    <b-modal ref="modal" centered hide-header  no-close-on-backdrop no-close-on-esc hide-footer size="lg">
        <div class="modal-header">
            <div class="modal-title">
                <h5>{{$t('USERSUBCOMPANIES')}}</h5>
            </div>
            <button type="button" aria-label="Close" @click="close()" class="close"><img src="../../../../assets/img/icon-close.svg"></button>
        </div>
        <div class="d-block mt-2 modal-content-inside">
          <div role="group" class="b-form-group form-group"  v-if="formData != null">
                <div class="form-row">
                    <div class="col-sm-6">
                    <b-form-fieldset v-bind:label="$t('NAME')">
                        <inputvalidation :formerror="formError" name="subCompanyName">
                        <b-form-input type="text" v-model="formData.subCompanyName"></b-form-input>
                        </inputvalidation>
                    </b-form-fieldset>
                    </div>
                    <div class="col-sm-6">
                    <b-form-fieldset v-bind:label="$t('ADDRESS')">
                        <inputvalidation :formerror="formError" name="address">
                        <b-form-input type="text" v-model="formData.address"></b-form-input>
                        </inputvalidation>
                    </b-form-fieldset>
                    </div>
                </div>
                <div class="form-row">
                    <div class="col-sm-6">
                    <b-form-fieldset v-bind:label="$t('POSTALCODE')">
                        <inputvalidation :formerror="formError" name="postalCode">
                        <b-form-input type="text" v-model="formData.postalCode"></b-form-input>
                        </inputvalidation>
                    </b-form-fieldset>
                    </div>
                    <div class="col-sm-6">
                    <b-form-fieldset v-bind:label="$t('CITY')">
                        <inputvalidation :formerror="formError" name="city">
                        <b-form-input type="text" v-model="formData.city"></b-form-input>
                        </inputvalidation>
                    </b-form-fieldset>
                    </div>
                </div>
                <div class="form-row">
                    <div class="col-sm-6">
                        <b-form-fieldset v-bind:label="$t('CONTACTPERSON')">
                            <inputvalidation :formerror="formError" name="taxNumber">
                            <b-form-input type="text" v-model="formData.taxNumber"></b-form-input>
                            </inputvalidation>
                        </b-form-fieldset>
                    </div>
                    <div class="col-sm-6">
                    <b-form-fieldset v-bind:label="$t('PHONE')">
                        <inputvalidation :formerror="formError" name="phone">
                        <b-form-input type="text" v-model="formData.phone"></b-form-input>
                        </inputvalidation>
                    </b-form-fieldset>
                    </div>
                </div>
                <div class="form-row">
                    <div class="col-sm-6">
                    <b-form-fieldset v-bind:label="$t('COUNTRY')">
                        <inputvalidation :formerror="formError" name="country">
                        <b-form-input type="text" v-model="formData.country"></b-form-input>
                        </inputvalidation>
                    </b-form-fieldset>
                    </div>
                    <div class="col-sm-6">
                    <b-form-fieldset v-bind:label="$t('USEREMAIL')">
                        <inputvalidation :formerror="formError" name="iban">
                        <b-form-input type="text" v-model="formData.iban"></b-form-input>
                        </inputvalidation>
                    </b-form-fieldset>
                    </div>
                </div>
                <div class="form-row" v-if="globals && globals.acl && globals.acl.UserCompanies && globals.acl.UserCompanies.insertAction">
                    <div class="col-sm-6">
                        <b-form-fieldset v-bind:label="$t('COMPANY')">
                            <inputvalidation :formerror="formError" name="companyId">
                                <div style="max-height: 150px; overflow-y: auto; border: 1px solid #ced4da; border-radius: 0.25rem; padding: 0.5rem;">
                                    <div v-for="company in userCompanies.root" :key="company.companyId" class="form-check">
                                        <input
                                            type="checkbox"
                                            class="form-check-input"
                                            :id="`company-${company.companyId}`"
                                            :value="company.companyId"
                                            :checked="selectedCompanies.some(c => c.companyId === company.companyId)"
                                            @click="() => onCompanyCheckboxClicked(company)"
                                        >
                                        <label class="form-check-label" :for="`company-${company.companyId}`">
                                            {{ company.companyName }}
                                        </label>
                                    </div>
                                </div>
                            </inputvalidation>
                        </b-form-fieldset>
                    </div>
                </div>
                </div>
          </div>
            <div class="text-center mt-lg mb-lg">
                <b-btn class="mr-2 btn-bis btn-cancel" @click="close()">{{$t('CANCEL')}}</b-btn>
                <b-btn class="btn-bis btn-primary" @click="submitData(formData)">{{$t('SAVE')}}</b-btn>
            </div>
    </b-modal>
</template>

<script>
import
{
    mapGetters,
}
    from 'vuex';
import Api from '@/api/admin/UserSubCompanies'
import CompaniesApi from '@/api/admin/UserCompanies'
import CompaniesRelationsApi from '@/api/admin/CompanySubCompanyRelations'


export default
{
    name: 'SubCompaniesForm',
    props: ['value'],
    data()
    {
        return {
            userCompanies: { root: [] },
            selectedCompanies: [],
            formError: {},
            formData: null,
        };
    },
    methods:
    {
        async submitData(item)
        {
            const me = this;
                try
                {
                    if (!item.subCompanyId) {
                        const selectedCompanyIds = me.selectedCompanies.map(company => company.companyId);
                        
                        if (item.companyIds && item.companyIds.length > 0) {
                            item.companyIds.forEach(id => {
                                if (!selectedCompanyIds.includes(id)) {
                                    selectedCompanyIds.push(id);
                                }
                            });
                        }
                        
                        if (selectedCompanyIds.length > 0) {
                            item.companyIds = selectedCompanyIds;
                        }
                    } else {
                        if (item.companyIds && item.companyIds.length > 0) {
                            item.associatedCompanyIds = item.companyIds;
                        }
                        delete item.companyIds;
                    }

                    if (typeof item.subCompanyId !== 'undefined')
                    {
                        item.id = item.subCompanyId;
                        delete (item.subCompanyId);
                    }

                    const val = await Api.save(item);

                    if (val.error)
                    {
                        me.$notify.notice(val);
                        me.formError = val;
                    }
                    else
                    {
                        me.$notify.notice(val);
                        me.close();
                    }
                }
                catch (error)
                {
                    me.$notify.notice(error);
                }
        },
        async getCompanies()
        {
            const me = this;
            try
            {
                const data = await CompaniesApi.selectRow({start:0, limit: 5000});
                if (data.error && data.error === true)
                {
                    throw (data);
                }
                me.userCompanies = data;
            }
            catch (error)
            {
                me.$notify.notice(error);
            }
        },
        async getCompaniesFromSubCompany(param)
        {
            const me = this;
            try
            {
                const data = await Api.getCompaniesFromSubCompany(param);
                if (data.error && data.error === true)
                {
                    throw (data);
                }
                if (data.root && Array.isArray(data.root)) {
                    me.selectedCompanies = data.root;
                } else {
                    me.selectedCompanies = [];
                }
            }
            catch (error)
            {
                console.error(error)
                me.$notify.notice(error);
            }
        },
        onCompanyCheckboxClicked(company)
        {
            const me = this;
            const companySelected = me.selectedCompanies.some(c => c.companyId === company.companyId)

            if (companySelected)
            {
                me.unselectCompany(company);
                return;
            }

            me.selectCompany(company);
        },
        async selectCompany(company)
        {
            const me = this;
            try
            {
                if (!me.formData.subCompanyId) {
                    if (!me.selectedCompanies.some(c => c.companyId === company.companyId)) {
                        me.selectedCompanies.push(company);
                    }
                    return;
                }
                
                const data = await CompaniesRelationsApi.insertRow({
                    companyId: company.companyId,
                    subCompanyId: me.formData.subCompanyId,
                });
                if (data.error && data.error === true)
                {
                    throw (data);
                }
            }
            catch (error)
            {
                me.$notify.notice(error);
            }
        },
        async unselectCompany(company)
        {
            const me = this;
            try
            {
                if (!me.formData.subCompanyId) {
                    me.selectedCompanies = me.selectedCompanies.filter(c => c.companyId !== company.companyId);
                    return;
                }
                
                let foundSelectedCompany = null;
                for (const selectedCompany of me.selectedCompanies)
                {
                    if (selectedCompany.companyId === company.companyId)
                    {
                        foundSelectedCompany = selectedCompany;
                    }
                }

                if (!foundSelectedCompany)
                {
                    return;
                }

                const data = await CompaniesRelationsApi.deleteRow({
                    id: foundSelectedCompany.relationId,
                });
                if (data.error && data.error === true)
                {
                    throw (data);
                }
            }
            catch (error)
            {
                me.$notify.notice(error);
            }
        },
        close()
        {
            const me = this;
            me.formData = null;
            me.formError = {};
            me.userCompanies = { root: [] };
            me.$emit('close');
        },
    },
    watch:
    {
        async formData(val)
        {
            const me = this;
            if (val != null)
            {
                if (!val.companyIds) {
                    val.companyIds = [];
                }
                await me.getCompanies();
                await me.getCompaniesFromSubCompany({
                    subCompanyId: val.subCompanyId,
                });

                me.$nextTick(() => {
                    me.$refs.modal.show();
                });
            }
            else
            {
                me.$refs.modal.hide();
            }
        },
        value(val)
        {
            const me = this;
            if (val != null)
            {
                me.formData = { ...val };
            }
            else
            {
                me.formData = null;
            }
        },
    },
    computed:
    {
        ...mapGetters([
            'globals',
        ]),
    },
};
</script>

<style scoped>
.form-check {
    display: block;
    padding: 0.25rem 0;
    margin-left: 0;
    padding-left: 1.25em;
}

.form-check-input {
    margin-top: 0.3em;
    margin-left: -1.25em;
}
</style>
